import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    const updateCartCount = () => {
      const savedCart = localStorage.getItem('cart');
      if (savedCart) {
        const cart = JSON.parse(savedCart);
        const count = cart.reduce((sum: number, item: { quantity: number }) => sum + item.quantity, 0);
        setCartCount(count);
      } else {
        setCartCount(0);
      }
    };
    updateCartCount();
    const interval = setInterval(updateCartCount, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex justify-between items-center h-14 md:h-16 lg:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 cursor-pointer group">
            {/* 로고 이미지 */}
            <div className="w-9 h-9 flex items-center justify-center group-hover:scale-105 transition-transform">
              <img
                src="https://static.readdy.ai/image/b75d658bdf38425358aca6a20c1537e8/b9aa7be5b44151ce0701a6a99e03d1ad.png"
                alt="송림코리아 로고"
                className="w-full h-full object-contain rounded-lg"
              />
            </div>
            {/* 텍스트 */}
            <div className="flex flex-col leading-tight">
              <span className="text-[#1A1A2E] font-extrabold text-lg md:text-xl tracking-tight" style={{ fontFamily: "'Anton', sans-serif" }}>
                송림코리아
              </span>
              <span className="text-[#E63946] text-[9px] md:text-[10px] font-semibold tracking-[0.15em] uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>
                SONGLIM KOREA
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8 lg:space-x-12">
            <Link
              to="/"
              className="text-[#1A1A2E] hover:text-[#E63946] transition-colors text-sm lg:text-base font-medium cursor-pointer"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              홈
            </Link>
            <Link
              to="/shop"
              className="text-[#1A1A2E] hover:text-[#E63946] transition-colors text-sm lg:text-base font-medium cursor-pointer"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              제품
            </Link>
            <Link
              to="/leather-guide"
              className="text-[#1A1A2E] hover:text-[#E63946] transition-colors text-sm lg:text-base font-medium cursor-pointer"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              부품 가이드
            </Link>
            <Link
              to="/contact"
              className="text-[#1A1A2E] hover:text-[#E63946] transition-colors text-sm lg:text-base font-medium cursor-pointer"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              문의
            </Link>
          </div>

          {/* Cart Icon + Mobile Menu */}
          <div className="flex items-center space-x-4 md:space-x-6">
            <Link to="/cart" className="relative cursor-pointer">
              <i className="ri-shopping-cart-line text-xl md:text-2xl text-[#1A1A2E] hover:text-[#E63946] transition-colors"></i>
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-[#E63946] text-white text-[10px] md:text-xs w-4 h-4 md:w-5 md:h-5 rounded-full flex items-center justify-center font-bold">
                  {cartCount}
                </span>
              )}
            </Link>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-[#1A1A2E] cursor-pointer p-1"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-1">
              <Link
                to="/"
                className="text-[#1A1A2E] hover:text-[#E63946] hover:bg-gray-50 transition-colors text-base font-medium cursor-pointer px-3 py-3 rounded-lg"
                style={{ fontFamily: "'Inter', sans-serif" }}
                onClick={() => setIsMenuOpen(false)}
              >
                홈
              </Link>
              <Link
                to="/shop"
                className="text-[#1A1A2E] hover:text-[#E63946] hover:bg-gray-50 transition-colors text-base font-medium cursor-pointer px-3 py-3 rounded-lg"
                style={{ fontFamily: "'Inter', sans-serif" }}
                onClick={() => setIsMenuOpen(false)}
              >
                제품
              </Link>
              <Link
                to="/leather-guide"
                className="text-[#1A1A2E] hover:text-[#E63946] hover:bg-gray-50 transition-colors text-base font-medium cursor-pointer px-3 py-3 rounded-lg"
                style={{ fontFamily: "'Inter', sans-serif" }}
                onClick={() => setIsMenuOpen(false)}
              >
                부품 가이드
              </Link>
              <Link
                to="/contact"
                className="text-[#1A1A2E] hover:text-[#E63946] hover:bg-gray-50 transition-colors text-base font-medium cursor-pointer px-3 py-3 rounded-lg"
                style={{ fontFamily: "'Inter', sans-serif" }}
                onClick={() => setIsMenuOpen(false)}
              >
                문의
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
